/**
 * Threshold in milliseconds before token expiration when we consider the token invalid.
 * This gives us a 10-second buffer to refresh the token before it actually expires.
 */
const EXPIRATION_THRESHOLD = 10000

/**
 * Checks if a JWT token is still valid based on its expiration time.
 *
 * @param expirationNumber - The token expiration timestamp in seconds (Unix epoch)
 * @returns boolean - True if the token is still valid with buffer time, false otherwise
 */
export const isTokenValid = (expirationNumber: number | undefined) => {
  if (!expirationNumber) {
    return false
  }
  const expirationTime = expirationNumber * 1000
  const currentTime = Date.now()
  const timeUntilExpiration = expirationTime - currentTime
  return timeUntilExpiration > EXPIRATION_THRESHOLD
}
